import connect from '../../utils/saga/connect';

export default connect([]);
